/* Package JSON Import will be here */
import React from "react";
import ReactPlayer from "react-player";
/* Package JSON Import will be here */

const VideoPlayer = (props: any) => {
    return (
        <div className='player-wrapper'>
            <ReactPlayer
                className='react-player'
                url={props.videoUrl}
                width='100%'
                height='100%'
                controls={true}
                loop={true}
                light={props.light}
                playing={true}
                config={{
                    file: {
                        attributes: {
                            controlsList: 'nodownload nofullscreen',
                            disablePictureInPicture: true
                        }
                    }
                }}
            />
        </div>
    )
}

export default VideoPlayer;